import React from 'react'
import * as R from 'ramda'

import { getLocalStorage, setLocalStorage } from 'utils/storage'

interface UseToggleOptions {
  key?: string
  isInitiallyToggled?: boolean
  isPersisted?: boolean
}

interface UseToggleReturn {
  handleToggle: () => void
  isToggled: boolean
}

export const useToggle = ({
  key,
  isInitiallyToggled = true,
  isPersisted = false,
}: UseToggleOptions = {}): UseToggleReturn => {
  if (R.isNil(key) && isPersisted) {
    throw new Error("It seems that 'key' has not been passed as a hook param.")
  }

  const persisted = getLocalStorage(key)
  const hasKeyStored = R.not(R.isNil(persisted))

  const [isToggled, setIsToggled] = React.useState(
    isPersisted && hasKeyStored ? persisted : isInitiallyToggled,
  )

  const handleToggle = React.useCallback(() => {
    setIsToggled(prevState => !prevState)
  }, [setIsToggled])

  React.useEffect(() => {
    if (isPersisted) {
      setLocalStorage(key, isToggled)
    }
  }, [key, isPersisted, isToggled])

  return { handleToggle, isToggled }
}
